/* globals jQuery, Modernizr, google, moment, EEB */
jQuery( $ => {
	const $document = $( document );
	const $page = $( 'html,body' );
	const $html = $( 'html' );
	const $body = $( 'body' );

	// =========================
	// ! Supports Flagging
	// =========================

	$body.removeClass( 'no-js' ).addClass( 'js' );

	$document
		.on( 'touchstart', function() {
			$body.removeClass( 'notouch' ).addClass( 'touch' );
		} )
		.on( 'mousedown', function() {
			$body.addClass( 'using-mouse' );
		} )
		.on( 'keydown', function() {
			$body.removeClass( 'using-mouse' );
		} );

	// =========================
	// ! Basic Setup
	// =========================

	// Dropdown widgets
	if ( 'customA11ySelect' in $.fn ) {
		$( 'select.dropdown' ).customA11ySelect();
	}

	// Datepicker inputs
	if ( 'datepicker' in $.fn ) {
		$( 'input.datepicker' ).datepicker( {
			format: 'yyyy-mm-dd',
		} );
	}

	// Jump To
	const scrollMargin = 50;
	$( 'a[href^="#"]' ).not( '.skip-to-content' ).click( function( e ) {
		e.preventDefault();

		if ( $( this ).hasClass( 'toggle' ) || $( this ).attr( 'rel' ) === 'tab' ) {
			return;
		}

		const $target = $( $( this ).attr( 'href' ) );

		if ( $target.hasClass( 'modal' ) ) {
			return $target.one( 'transitionend', function() {
				$( this ).trigger( 'modal:shown' );
			} ).addClass( 'is-active' ).trigger( 'modal:show' );
		}

		let position = 0;
		if ( $target.length > 0 ) {
			position = $target.offset().top - scrollMargin;
		}

		$page.animate( { scrollTop: position } );
	} );

	$( '.modal' ).click( function( e ) {
		if ( $( e.target ).hasClass( 'modal' ) || $( e.target ).hasClass( 'modal-close' ) ) {
			return $( '.modal' ).one( 'transitionend', function() {
				$( this ).trigger( 'modal:hidden' );
			} ).removeClass( 'is-active' ).trigger( 'modal:hide' );
		}
	} );

	// =========================
	// ! Text Fixes
	// =========================

	$( 'a' ).each( function() {
		if ( $( this ).children().length > 0 ) {
			return;
		}

		let html = $( this ).html();

		html = html.replace( /([#_@]+)(\S)/g, '<wbr />$1$2' );
		html = html.replace( /([\?\/]+)(?!>)/g, '$1<wbr />' );

		$( this ).html( html );
	} );

	// =========================
	// ! Accordion
	// =========================

	$( '.eeb-accordion__header' ).each( function() {
		const $parent = $( this ).parents( '.eeb-accordion-group' ).first();
		const $header = $( this );
		const $target = $header.next();

		$header.click( function() {
			$header.toggleClass( 'is-active' );
			if ( $header.hasClass( 'is-active' ) ) {
				$target.addClass( 'open' ).stop().hide().animate( { height: 'toggle' }, () => $target.attr( 'style', '' ) );
				$parent.find( '.eeb-accordion__header' ).not( $header ).each( function() {
					if ( $( this ).hasClass( 'is-active' ) ) {
						$( this ).removeClass( 'is-active' );
						$( this ).next().stop().show().animate( { height: 'toggle' }, () => $( this ).next().attr( 'style', '' ).removeClass( 'open' ) );
					}
				} );
			} else {
				$target.stop().show().animate( { height: 'toggle' }, () => $target.attr( 'style', '' ).removeClass( 'open' ) );
			}
		} );
	} );

	// =========================
	// ! Top Bar Accordion
	// =========================

	$( '.top-bar-menu-toggle' ).click( function() {
		const $this = $( this );
		const $topBar = $this.parent();
		const $target = $this.siblings( '.wrapper' );

		if ( $topBar.hasClass( 'is-active' ) ) {
			$topBar.removeClass( 'is-active' );
			$target.removeClass( 'open' );
		} else {
			$topBar.addClass( 'is-active' );
			$target.addClass( 'open' );
		}
	} );

	// =========================
	// ! Submenu Toggle Buttons
	// =========================

	$( '.menu-item-has-children' ).each( function() {
		const $this = $( this );
		const $toggleButton = $( '<button class="sub-menu-toggle icon icon-chevron-down" type="button"></button>' );
		$this.append( $toggleButton );
	} );

	// =========================
	// ! Flyout, Footer Accordion
	// =========================

	$( '.sub-menu-toggle' ).each( function() {
		const $toggle = $( this );
		const $parent = $toggle.parent();
		const $target = $toggle.siblings( '.wrapper' );

		$toggle.click( function() {
			$parent.toggleClass( 'is-active' );
			if ( $parent.hasClass( 'is-active' ) ) {
				$target.addClass( 'open' ).stop().hide().animate( { height: 'toggle' }, () => $target.attr( 'style', '' ) );
				$parent.siblings( '.menu-item-has-children' ).each( function() {
					if ( $( this ).hasClass( 'is-active' ) ) {
						$( this ).removeClass( 'is-active' );
						$( this ).find( '.wrapper' ).stop().show().animate( { height: 'toggle' }, () => $( this ).find( '.wrapper' ).attr( 'style', '' ).removeClass( 'open' ) );
					}
				} );
			} else {
				$target.stop().show().animate( { height: 'toggle' }, () => $target.attr( 'style', '' ).removeClass( 'open' ) );
			}
		} );
	} );

	// =========================
	// ! Filter Flyouts
	// =========================

	$( '.dropdown-control__label' ).each( function() {
		const $thisFilter = $( this );
		const $parent = $( this ).parents( '.directory-controls__filters' ).first();

		$thisFilter.click( function() {
			if ( $thisFilter.hasClass( 'is-active' ) ) {
				$thisFilter.removeClass( 'is-active' );
			} else {
				$parent.find( '.dropdown-control__label' ).not( $thisFilter ).each( function() {
					if ( $( this ).hasClass( 'is-active' ) ) {
						$( this ).removeClass( 'is-active' );
					}
				} );

				$thisFilter.addClass( 'is-active' );
			}
		} );
	} );

	$document.click( function( e ) {
		if ( ! $( e.target ).hasClass( 'dropdown-control' ) && $( e.target ).parents( '.dropdown-control' ).length === 0 ) {
			$( '.dropdown-control__label' ).removeClass( 'is-active' );
		}
	} );

	// =========================
	// ! Toggle Buttons
	// =========================

	$( '.toggle[href^="#"], [rel="toggle"], [data-toggle]' ).click( function( e ) {
		if ( this.tagName.toLowerCase() === 'a' ) {
			e.preventDefault();
		}

		const target = $( this ).data( 'toggle' ) || $( this ).attr( 'href' ).replace( '#', '' );

		const className = `show-${ target }`;

		if ( $body.hasClass( className ) ) {
			$body.removeClass( className ).trigger( `toggle:${ target }:off` );
		} else {
			$body.addClass( className ).trigger( `toggle:${ target }:on` );
		}
	} );

	$( '#show_alternate' ).change( function() {
		$body.toggleClass( 'showing-alternate', this.checked );
	} );

	// =========================
	// ! Directory Filtering
	// =========================

	const $directoryCount = $( '.js-directory-count' );
	const $directoryList = $( '.eeb-directory' );
	const $directoryItems = $( '.eeb-directory-item' );

	function updateDirectoryCount() {
		$directoryCount.text( $directoryItems.filter( ':visible' ).length );
	}

	const $directoryFilters = $( '[data-directory-filter]' );
	$directoryFilters.change( function() {
		$directoryItems.removeClass( 'matched-filter' );

		let filter = '';
		$directoryFilters.filter( ':checked' ).each( function() {
			filter += '.' + $( this ).data( 'directory-filter' );
		} );

		$directoryList.toggleClass( 'show-matching-filter', !! filter );

		if ( filter ) {
			$directoryItems.filter( filter ).addClass( 'matched-filter' );
		}

		updateDirectoryCount();
	} );

	// Query arg updating
	if ( typeof URLSearchParams !== 'undefined' ) {
		const filterQuery = new URLSearchParams( decodeURI( location.search ) );

		const $directoryFilterTags = $( '.directory-filter-tag' );
		$directoryFilterTags.each( function() {
			const href = $( this ).attr( 'href' ).split( /[?#]/ );

			$( this ).data( 'href', {
				pathname: href[ 0 ],
				search: new URLSearchParams( decodeURI( href[ 1 ] ) ),
				fragment: href[ 2 ] || '',
			} );
		} );

		$directoryFilters.change( function() {
			const name = this.name;
			const values = [];

			$directoryFilters.filter( ':checked' ).each( function() {
				values.push( this.value );
			} );

			filterQuery.delete( name );
			filterQuery.delete( name.replace( '[]', '' ) );
			values.forEach( value => filterQuery.append( name, value ) );

			$directoryFilterTags.each( function() {
				const href = $( this ).data( 'href' );

				href.search.delete( name );
				values.forEach( value => href.search.append( name, value ) );

				$( this ).attr( 'href', href.pathname + '?' + href.search.toString() + '#' + href.fragment );
			} );

			const queryString = filterQuery.toString();
			history.pushState( {}, '', window.location.pathname + ( queryString ? `?${ queryString }` : '' ) );
		} );
	}

	$( '.eeb-directory[data-directory-search]' ).each( function() {
		const $search = $( $( this ).data( 'directory-search' ) ).find( 'input[type=search]' ).first();

		$directoryItems.each( function() {
			$( this ).data( 'text', $( this ).find( '.eeb-directory-item__title' ).text().toLowerCase() );
		} );

		$search.on( 'input', function() {
			const query = this.value.toLowerCase().replace( /[^\w\s\-]+/g, '' ).split( ' ' ).filter( v => v );

			$directoryList.toggleClass( 'show-matching-search', query.length > 0 );

			if ( query.length === 0 ) {
				$directoryItems.removeClass( 'matched-search' );
				return;
			}

			$directoryItems.removeClass( 'matched-search' ).each( function() {
				const text = $( this ).data( 'text' );

				for ( let word of query ) {
					word = word.trim();
					if ( text.indexOf( word ) >= 0 ) {
						$( this ).addClass( 'matched-search' );
						break;
					}
				}
			} );

			updateDirectoryCount();
		} );
	} );

	$( '#show_alternate' ).change( updateDirectoryCount );

	setTimeout( function() {
		$( '.search-bar input' ).trigger( 'input' );
		$directoryFilters.change();
		updateDirectoryCount();
	}, 100 );

	// =========================
	// ! Page Nav Handling
	// =========================

	const pageNavTransition = 500;

	$body.on( 'toggle:page-nav:on', function() {
		$( '.page-nav__content' ).stop().hide().animate( { height: 'toggle' }, pageNavTransition, 'easeOutSine' );
	} ).on( 'toggle:page-nav:off', function() {
		$( '.page-nav__content' ).stop().show().animate( { height: 'toggle' }, pageNavTransition, 'easeOutSine' );
	} );

	$document.click( function( e ) {
		const $target = $( e.target );

		if ( $body.hasClass( 'show-page-nav' ) && ! $target.hasClass( '.page-nav' ) && $target.parents( '.page-nav' ).length === 0 ) {
			$body.removeClass( 'show-page-nav' ).trigger( 'toggle:page-nav:off' );
		}
	} );

	// =========================
	// ! Tab-Nav Functionality
	// =========================

	$( '.tabnav' ).each( function() {
		const $marker = $( '<i class="tabnav-marker noanimation"></i>' ).appendTo( this );

		function updateMarker( $item ) {
			let left = 0,
				width = 0;

			if ( $item.length > 0 ) {
				left = $item.position().left + 'px';
				width = $item.width() + 'px';
			}

			$marker.css( { left, width } );
		}

		$( this ).on( 'mouseenter', '.tabnav-item', function() {
			updateMarker( $( this ) );
		} );

		$( this ).on( 'mouseleave', function() {
			updateMarker( $( this ).find( '.tabnav-item.is-active' ) );
		} );

		updateMarker( $( this ).find( '.tabnav-item.is-active' ) );
		setTimeout( () => $marker.removeClass( 'noanimation' ) );
	} );

	$( '.tabnav' ).click( function() {
		$( this ).toggleClass( 'is-open' );
	} );

	$( '.tabnav-item' ).click( function() {
		$( this ).addClass( 'is-active' ).siblings().removeClass( 'is-active' );
	} );

	// =========================
	// ! Intersection Observers
	// =========================

	if ( typeof IntersectionObserver !== 'undefined' ) {
		const topMargin = $html.css( 'margin-top' ) || '0px';

		// =========================
		// ! - Page Nav Scroll Spy
		// =========================

		const $links = $( '.page-nav__links a' );
		const $ticker = $( '.page-nav__ticker' );

		const headingObserver = new IntersectionObserver( changes => {
			changes.forEach( change => {
				const $link = $links.filter( `a[href="#${ change.target.id }"]` );
				if ( change.intersectionRatio === 0 ) {
					$link.removeClass( 'is-active' );
				} else {
					$link.addClass( 'is-active' );
				}
			} );

			if ( Modernizr.customproperties ) {
				const $current = $links.filter( '.is-active' ).last();
				if ( $current.length > 0 ) {
					const index = $current.index( '.page-nav__links a' );
					$ticker[ 0 ].style.setProperty( '--index', index + 1 );
				}
			}
		}, {
			margin: `${ topMargin } 0 50px`,
		} );

		$( '.page-content h2[id]' ).each( function() {
			headingObserver.observe( this );
		} );

		// =========================
		// ! - Sticky Identifier
		// =========================

		const stickyObserver = new IntersectionObserver( changes => {
			changes.forEach( change => {
				if ( change.intersectionRatio === 1 ) {
					$( change.target ).data( 'target' ).removeClass( 'is-sticky' );
				}
				if ( change.intersectionRatio === 0 ) {
					$( change.target ).data( 'target' ).addClass( 'is-sticky' );
				}
			} );
		}, {
			margin: `${ topMargin }px 0 0`,
			threshold: [ 0, 1 ],
		} );

		$( '.sticky-marker' ).each( function() {
			const target = $( this ).data( 'target' );
			$( this ).data( 'target', $( `#${ target }` ) );
			stickyObserver.observe( this );
		} );

		// =========================
		// ! - In-view Identifier
		// =========================

		const inviewObserver = new IntersectionObserver( changes => {
			changes.forEach( change => {
				if ( change.intersectionRatio > 0 ) {
					$( change.target ).addClass( 'in-view' );
				}
			} );
		}, {
			margin: `${ topMargin }px 0 0`,
		} );

		$( '.page-content, .post-content' ).children().each( function() {
			inviewObserver.observe( this );
		} );
	}

	// =========================
	// ! Block Functionality
	// =========================

	// =========================
	// ! - Feature Block
	// =========================

	$( '.eeb-feature__view-button' ).click( function() {
		const $feature = $( this ).parents( '.eeb-feature' );
		const [ feature ] = $feature;

		if ( $feature.hasClass( 'is-magnified' ) ) {
			$feature.removeClass( 'is-magnified' );
			return;
		}

		if ( document.fullscreen ) {
			if ( document.fullscreenElement === feature ) {
				if ( document.exitFullscreen ) {
					document.exitFullscreen();
				} else if ( document.mozCancelFullScreen ) { // Firefox
					document.mozCancelFullScreen();
				} else if ( document.webkitExitFullscreen ) { // Chrome, Safari and Opera
					document.webkitExitFullscreen();
				} else if ( document.msExitFullscreen ) { // IE/Edge
					document.msExitFullscreen();
				}
			} else {
				$feature.toggleClass( 'is-magnified' );
			}

			return;
		}

		if ( feature.requestFullscreen ) {
			feature.requestFullscreen();
		} else if ( feature.mozRequestFullScreen ) { // Firefox
			feature.mozRequestFullScreen();
		} else if ( feature.webkitRequestFullscreen ) { // Chrome, Safari and Opera
			feature.webkitRequestFullscreen();
		} else if ( feature.msRequestFullscreen ) { // IE/Edge
			feature.msRequestFullscreen();
		} else {
			$( feature ).toggleClass( 'is-magnified' );
		}
	} );

	// =========================
	// ! - Embed Blocks
	// =========================

	$( '.eeb-embed' ).one( 'click', function() {
		const content = $( this ).find( '.eeb-embed__object' ).remove().html();

		$( this ).prepend( content );
	} );

	// =========================
	// ! Form Logic
	// =========================

	$( '.select-proxy' ).each( function() {
		$( this ).wrap( '<div class="select-control"></div>' );

		const $toggle = $( `<label for="${ this.id }" class="select-control__label"></label>` );
		$( this ).after( $toggle );

		$( this ).change( function() {
			$toggle.text( $( this ).find( 'option:selected' ).text() );
		} ).change();
	} );

	function checkField( field, value ) {
		const $field = $( `[name="${ field }"]` );

		let test = true;
		if ( typeof value === 'string' ) {
			if ( value.indexOf( '!' ) === 0 ) {
				test = false;
				value = value.substr( 1 );
			}
		}

		let filled = false;
		$field.each( function() {
			if ( this.type === 'radio' || this.type === 'checkbox' ) {
				if ( this.checked && this.value === value ) {
					filled = true;
				}
			} else
			if ( this.value === value || ( value === true && this.value !== '' ) ) {
				filled = true;
			}
		} );

		return filled === test;
	}

	$( '[data-display]' ).addClass( 'hidden' ).each( function() {
		const $this = $( this );
		const rule = $this.data( 'display' );
		const [ field, value = true ] = rule.split( '=' );

		const $field = $( `[name="${ field }"]` );
		$field.on( 'input change', function() {
			$this.toggleClass( 'hidden', ! checkField( field, value ) );
		} ).trigger( 'input' );
	} );

	$( '.autosubmit' ).change( function() {
		$( this ).parents( 'form' ).submit();
	} );

	// =========================
	// ! - Datepicker Variants
	// =========================

	$( '.datepicker-control' ).each( function() {
		const $this = $( this );
		const $input = $this.find( '.datepicker-input' );

		$this.datepicker( {
			format: 'yyyy-mm-dd',
			date: $input.val(),
			autoHide: true,
			pick( e ) {
				e.preventDefault();
				const date = $this.datepicker( 'formatDate', e.date );
				$input.val( date );

				if ( e.view === 'day' ) {
					$input.trigger( 'change' );
				}
			},
		} );
	} );

	$( '.datetime-control__date' ).each( function() {
		const $this = $( this );
		const $input = $this.find( '.datepicker-input' );
		const $month = $this.find( '.datepicker-month' );
		const $day = $this.find( '.datepicker-day' );

		$this.datepicker( {
			format: 'yyyy-mm-dd',
			date: $input.val(),
			startDate: new Date(),
			pick( e ) {
				e.preventDefault();
				const value = $this.datepicker( 'formatDate', e.date );
				const date = moment( e.date );

				$month.text( date.format( 'ddd, MMMM' ) );
				$day.text( date.format( 'Do' ) );

				$input.val( value ).trigger( 'change' );
			},
		} );
	} );

	// =========================
	// ! - Booking Form
	// =========================

	const DAY_IN_SECONDS = 60 * 60 * 24;
	const WEEK_IN_SECONDS = DAY_IN_SECONDS * 7;
	const MONTH_IN_SECONDS = DAY_IN_SECONDS * 30;

	$( '.checkbox-card input[type="radio"]' ).on( 'change', function() {
		$( '.checkbox-card' ).removeClass( 'is-selected' );
		$( this ).parents( '.checkbox-card' ).addClass( 'is-selected' );
	} );

	// Update "by" option labels for monthyl/yearly
	const localeData = moment.localeData();
	$( '#booking_start_date' ).on( 'change input', function() {
		const date = moment( this.value, 'YYYY-MM-DD' );

		const weekday = date.format( 'dddd' );
		const monthday = date.format( 'Do' );
		const month = date.format( 'MMMM' );

		const day = parseInt( date.format( 'D' ) );
		const daynum = Math.ceil( day / 7 );
		const dayordinal = daynum > 4 ? 'Last' : localeData.ordinal( daynum );

		$( '#monthly_by [value="setpos"], #monthly_by-menu [data-val="setpos"] button' ).text( `${ dayordinal } ${ weekday } of the month` );
		$( '#monthly_by [value="monthday"], #monthly_by-menu [data-val="monthday"] button' ).text( `${ monthday } of the month` );
		$( '#monthly_by' ).trigger( 'input' );

		$( '#yearly_by [value="setpos"], #yearly_by-menu [data-val="setpos"] button' ).text( `${ dayordinal } ${ weekday } of ${ month }` );
		$( '#yearly_by [value="monthday"], #yearly_by-menu [data-val="monthday"] button' ).text( `${ monthday } of ${ month }` );
		$( '#yearly_by' ).trigger( 'input' );
	} ).change();

	// Disable smaller repeat options if start/end dates are too distant
	$( '#booking_start_date, #booking_end_date' ).change( function() {
		const start = new Date( $( '#booking_start_date' ).val() );
		const end = new Date( $( '#booking_end_date' ).val() );

		const diff = ( end - start ) / 1000;

		$( '#frequency [value="daily"]' ).attr( 'disabled', diff >= DAY_IN_SECONDS );
		$( '#frequency [value="weekly"]' ).attr( 'disabled', diff >= WEEK_IN_SECONDS );
		$( '#frequency [value="monthly"]' ).attr( 'disabled', diff >= MONTH_IN_SECONDS );

		$( '#weekly_byday' ).toggleClass( 'hidden', diff >= DAY_IN_SECONDS )
			.find( 'input' ).attr( 'disabled', diff >= DAY_IN_SECONDS );

		const frequency = $( '#frequency' ).val();
		if ( ! frequency ) {
			$( '#frequency' ).val( 'none' ).change();
		}
	} );

	// Update end date if start date changes/is past
	$( '#booking_start_date' ).change( function() {
		const start = $( this ).val();
		const end = $( '#booking_end_date' ).val();

		$( '#booking_end_date' ).parent().datepicker( 'setStartDate', start );
		if ( start > end ) {
			$( '#booking_end_date' ).parent().datepicker( 'setDate', start );
		}
	} ).change();

	// Update recurrence until if end date changes/is past
	$( '#booking_end_date' ).change( function() {
		const end = $( this ).val();
		const until = $( '#recurrence_until' ).val();

		$( '#recurrence_until' ).attr( 'min', end );
		if ( end > until ) {
			$( '#recurrence_until' ).val( end );
		}
	} ).change();

	// Update end time if start time changes/is past
	$( '#booking_start_time' ).change( function() {
		const start = $( this ).val();
		const end = $( '#booking_end_time' ).val();

		if ( start > end ) {
			$( '#booking_end_time' ).val( start ).trigger( 'change' );
		}
	} ).change();

	const $bookingFields = $( '.affects-booking-search' ).find( 'input, select' );
	const $bookingAvailabilityTitle = $( '#available_rooms_title' );
	const $bookingAvailabilityList = $( '#available_rooms' );

	function getBookableAvailability() {
		const data = $( '.affects-booking-search' ).serialize();

		$.ajax( {
			url: EEB.bookings_search_url,
			type: 'GET',
			data,
			success( { title, items } ) {
				// Sort conflicts after available ones
				items.sort( item => item.indexOf( 'has-conflicts' ) >= 0 ? 1 : 0 );

				$bookingAvailabilityTitle.text( title );
				$bookingAvailabilityList.html( items );

				$bookingAvailabilityList.children().each( function() {
					$( this ).find( '.booking-option-availability' ).slice( 1 ).wrapAll( '<div class="booking-option-availability__more"></div>' );
				} );
			},
			error( { responseText, responseJSON } ) {
				if ( ! responseJSON ) {
					/* eslint-disable-next-line no-alert */
					alert( 'Unknown error, please try again' );
					/* eslint-disable-next-line no-console */
					console.log( responseText );
				}
			},
		} );
	}

	$bookingFields.change( getBookableAvailability );
	$( '#new-booking' ).on( 'modal:show', getBookableAvailability );

	$bookingAvailabilityList.on( 'click', '.booking-option', function( e ) {
		if ( $( e.target ).is( 'a, input, button, label' ) ) {
			return;
		}

		$( this ).find( '.booking-option__input' ).attr( 'checked', true ).trigger( 'change' );
	} );

	$bookingAvailabilityList.on( 'change', '.booking-option__input', function() {
		const $parent = $( this ).parents( '.booking-option' ).toggleClass( 'is-selected', this.checked );
		$( '.booking-option' ).not( $parent ).removeClass( 'is-selected' );
	} );

	$bookingAvailabilityList.on( 'click', '.booking-option__toggle', function() {
		const $entry = $( this ).parents( '.booking-option' );
		const $more = $entry.find( '.booking-option-availability__more' );

		$entry.toggleClass( 'is-expanded' );

		if ( $entry.hasClass( 'is-expanded' ) ) {
			$more.stop().hide().animate( { height: 'toggle' } );
			$( this ).attr( 'data-label', 'Collapse' );
		} else {
			$more.stop().show().animate( { height: 'toggle' } );
			$( this ).attr( 'data-label', 'Expand' );
		}
	} );

	$( '#new-booking' ).submit( function( e ) {
		e.preventDefault();
		const $form = $( this );

		$.ajax( {
			url: EEB.bookings_request_url,
			type: 'POST',
			data: $form.serialize(),
			success() {
				$form.addClass( 'is-submitted' );
			},
			error( { responseText, responseJSON } ) {
				if ( ! responseJSON ) {
					/* eslint-disable-next-line no-alert */
					alert( 'Unknown error, please try again' );
					/* eslint-disable-next-line no-console */
					console.log( responseText );
				}

				const { code, data } = responseJSON;

				switch ( code ) {
					case 'rest_missing_callback_param':
						/* eslint-disable-next-line no-alert */
						alert( 'One or more fields were missing, please review and try again.' );
						for ( const param of data.params ) {
							$( `[name="${ param }"]` ).parents( '.form-field' ).addClass( 'is-invalid' );
						}
						break;
					case 'rest_invalid_param':
						/* eslint-disable-next-line no-alert */
						alert( 'One or more fields were invalid, please review and try again.' );
						for ( const param in data.params ) {
							$( `[name="${ param }"]` ).parents( '.form-field' ).addClass( 'is-invalid' ).attr( 'data-error', data.params[ param ] );
						}
						break;
				}
			},
			complete() {
				$form.animate( { scrollTop: 0 } );
			},
		} );
	} ).on( 'modal:hidden', function() {
		if ( $( this ).hasClass( 'is-submitted' ) ) {
			this.reset();
			$( this ).removeClass( 'is-submitted' );
		}
	} );

	$( '.form-field' ).on( 'change input', function() {
		$( this ).removeClass( 'is-invalid' );
	} );

	// =========================
	// ! Google Map Handling
	// =========================

	if ( typeof google !== 'undefined' ) {
		$( '.eeb-google-map[data-config]' ).each( function() {
			const config = $( this ).data( 'config' );
			const { coords, ...options } = config;

			const map = new google.maps.Map( this, {
				center: coords,
				...options,
			} );

			const marker = new google.maps.Marker( {
				position: map.getCenter(),
			} );

			marker.setMap( map );
		} );
	}
} );
